import { LoggerInterface } from "@interfaces/LoggerInterface";
import { WidgetInterface } from "@interfaces/WidgetInterface";

import InstagramGalleryServiceInstagramPageAdapter from "./adapters/InstagramGalleryServiceInstagramPageAdapter";
import InstagramPostsServiceMainOrInstagramPageAdapter from "./adapters/InstagramPostsServiceMainOrInstagramPageAdapter";
import { INSTAGRAM_PAGE_WIDGET } from "./constants";
import InstagramGalleryWidget from "./InstagramGalleryWidget";
import { InstagramGalleryWidgetConfigInterface } from "./InstagramGalleryWidgetConfig";

class InstagramGalleryInstagramPageWidget
    extends InstagramGalleryWidget
    implements WidgetInterface
{
    constructor(
        config: InstagramGalleryWidgetConfigInterface,
        logger: LoggerInterface
    ) {
        super(config, logger, INSTAGRAM_PAGE_WIDGET);
        this.galleryServiceAdapter =
            new InstagramGalleryServiceInstagramPageAdapter(
                this.galleryService
            );
        this.postsServiceAdapter =
            new InstagramPostsServiceMainOrInstagramPageAdapter(
                this.postsService
            );
    }
}

export default InstagramGalleryInstagramPageWidget;
